import { render, staticRenderFns } from "./EducationPDFLessonsAddLesson.vue?vue&type=template&id=4042891c&"
import script from "./EducationPDFLessonsAddLesson.vue?vue&type=script&lang=js&"
export * from "./EducationPDFLessonsAddLesson.vue?vue&type=script&lang=js&"
import style0 from "./EducationPDFLessonsAddLesson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports